module.exports = __webpack_public_path__ + "static/media/image4.ad2d0dcd.jpg";